import { render, staticRenderFns } from "./adReportForms.vue?vue&type=template&id=4483a9e1&scoped=true&"
import script from "./adReportForms.vue?vue&type=script&lang=ts&"
export * from "./adReportForms.vue?vue&type=script&lang=ts&"
import style0 from "./adReportForms.vue?vue&type=style&index=0&id=4483a9e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4483a9e1",
  null
  
)

export default component.exports